import React, { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Select } from "uikit";

import LocalMultiSelect from "../..";

const capitalizeFirstLetter = (value: string) => {
	if (!value) return value;
	return value.charAt(0).toUpperCase() + value.slice(1);
};

const Selected: React.FC<Selected.Props> = (props) => {
	const context = useContext(LocalMultiSelect.Context);
	const { t } = useTranslation();

	const label = useMemo(
		() =>
			context?.all && context?.areAllOptionsSelected
				? capitalizeFirstLetter(
						context.allLabel ?? t("filter.options.all") ?? "all",
				  )
				: context?.value
						?.map(
							(selected) =>
								context.options?.find(
									(option) => option.key === selected,
								)?.label,
						)
						.join(", "),
		[
			context?.all,
			context?.allLabel,
			context?.areAllOptionsSelected,
			context?.options,
			context?.value,
			t,
		],
	);

	return (
		<Select.Text {...props} selected={(context?.value?.length ?? 0) > 0}>
			{label || context?.placeholder}
		</Select.Text>
	);
};

declare namespace Selected {
	type Props = Select.SelectedComponentBase.Props;
}

export default Selected;
